import axios from "axios";

export default function getWarrantyClaimDetail(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `/consumer/admin/api/v1/prife/claim/${parameters.id}?reimbursement_id=${parameters.reimbursement_id}`
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
